import type { AppEnvironment } from './environment.types';

/**
 * Local / non-production (`ng serve`, `ng build --configuration=development`).
 * Production builds replace this file with `environment.prod.ts`.
 *
 * **API URL:** Calls go to `apiBaseUrl` below. Your backend must allow CORS from the dev app
 * origin (e.g. `http://localhost:4200`). If you cannot enable CORS, set `apiBaseUrl` to `''` and
 * use `proxy.conf.json` (same `target` as this host) so `/api` is proxied during `ng serve`.
 */
export const environment: AppEnvironment = {
  production: false,
  //apiBaseUrl: 'https://localhost:7028',
  apiBaseUrl: 'https://service-rfi-job-operation-api-dev.retailfixitapp.com',
};
